// sampleData.js
const sampleData = {
  subscription: {
    start_date: "2025-01-02",
    plan: "Gold",
    expiry_date: "2026-03-31",
  },
  production: {
    mo_released_today: 12,
    planned_qty: 35000,
    produced_reels: 120,
    produced_reams: 5400,
    produced_bundle_pallet: 84,
  },
  sales: {
    new_orders_today: 22,
  },
  warehouse: {
    reels_received: 95,
    bundles_received: 41,
    ream_pallet_received: 18,
  },
  machine_production: [
    { machine: "Winder - 01", qty: 12500 },
    { machine: "Winder - 02", qty: 9800 },
    { machine: "Cutter - 01", qty: 4500 },
    { machine: "Cutter - 02", qty: 6100 },
  ],
};

export default sampleData;
